export default "__VITE_ASSET__a2243124__"